import { useMutation } from '@tanstack/react-query';
import { patchUserProfile, PatchUserProfileInput } from '@uplift/api';

export const useUpdateAvatar = (userId: string) => {
  const profileMutation = useMutation({
    mutationFn: (input: PatchUserProfileInput) => patchUserProfile(userId, input)
  });

  const updateAvatar = async (variables: PatchUserProfileInput) => {
    try {
      const response = await profileMutation.mutateAsync(variables);

      if (response) {
        return { data: response };
      }
    } catch (error) {
      return {
        error,
      };
    }
  };

  return {
    updateAvatar,
  };
};
